const getUrlParams = url => {
  if (!url) return url;

  const regex = /[?&]([^=#]+)=([^&#]*)/g;
  const params = {};
  let match = [];

  while ((match = regex.exec(url))) {
    params[match[1]] = match[2];
  }
  return params;
};

export default getUrlParams;
